(function() {

	'use strict';

	angular.module( 'showcaseModules' ).service( 'wallpreview',
			['$rootScope','$timeout','$sce','$q','$ApiHandler','$interpolate','$templateCache','$http','gettextCatalog',
	function( $rootScope,  $timeout,  $sce,  $q,  $ApiHandler,  $interpolate,  $templateCache,  $http,  gettextCatalog ) {

		var self = this;

		this.$opening = false;

		this.init = function( $scope ) {

			initWallPreview();

			function initWallPreview() {

				$scope.wallpreview = {};

				$scope.wallpreview.loop = function() {
					if (!$scope.wallpreview.context) return;

					try {
						$scope.wallpreview.render();
						requestAnimationFrame( $scope.wallpreview.loop );
					} catch( error ){
						console.error( error );
					}
				};

				$scope.wallpreview.open = function() {
					if ($scope.wallpreview.walls.length == 0) {
						console.error('No suitable walls');
					} else {
						$scope.show_wall_preview = true;

						if ($scope.wallpreview.walls.length > 1) {
							return $scope.wallpreview.openselect();
						} else {
							$scope.wallpreview.show_wall = true;
							return $scope.wallpreview.openview( $scope.wallpreview.walls[0] );
						}
					}
				};

				$scope.wallpreview.close = function() {
					if (!$scope.show_wall_preview) return;

					self.$opening = false;

					$scope.show_wall_preview = false;
					$scope.show_wall = false;
					$scope.show_wall_select = false;
					$scope.wallpreview.context = null;
				
					if ($scope.wallpreview.canvas != null) {
						$scope.wallpreview.canvas.remove();
					}
				
					document.body.removeEventListener( "mouseup",     $scope.wallpreview.onPointerUp);
					document.body.removeEventListener( "touchcancel", $scope.wallpreview.onPointerUp);
					document.body.removeEventListener( "touchend",    $scope.wallpreview.onPointerUp);

					$rootScope.$broadcast( "wall_preview.close" );
				};

				$scope.wallpreview.openselect = function() {
					return $timeout(function(){
						console.log('PreviewApp :: open wall select');
						$scope.wallpreview.show_wall_select  = true;
						$scope.wallpreview.show_wall = false;
					});
				};

				$scope.wallpreview.wallselected = function( wall ){
					return $timeout(function(){
						console.log('PreviewApp :: wall selected');
						$scope.wallpreview.show_wall_select = false;
						$scope.wallpreview.show_wall = true;
						return $scope.wallpreview.openview( wall );
					});
				}


				$scope.wallpreview.onPointerDown = function( event ){
					var point = pointFromEvent( event );
					$scope.wallpreview.selection.target = solveTargetByPoint( point );
				};
				$scope.wallpreview.onPointerMove = function( event ){
					if (event.which != 1 && event.type != "touchmove") {
						$scope.wallpreview.onPointerUp();
					} else if ($scope.wallpreview.selection.target) {
						var point = pointFromEvent( event );
						$scope.wallpreview.setOeuvrePositionByPoint( $scope.wallpreview.selection.target.oeuvre, {
							x: point.x - $scope.wallpreview.selection.target.dx,
							y: point.y - $scope.wallpreview.selection.target.dy
						});
					}
				}
				$scope.wallpreview.onPointerUp = function( event ){
					$scope.wallpreview.selection.target = null;
				};

				$scope.wallpreview.setOeuvrePositionByPoint = function( oeuvre, point ){	
					switch( oeuvre.plane.style ){
						case 3:
						default: 
							oeuvre.x = point.x;
							oeuvre.y = point.y;
						
							var	w = oeuvre.oeuvre.with.oeuvre.width;
							var	h = oeuvre.oeuvre.with.oeuvre.height;

							if (oeuvre.framing.canvas && oeuvre.framing.canvas.sides) {
								w += oeuvre.framing.canvas.sides.l + oeuvre.framing.canvas.sides.r;
								h += oeuvre.framing.canvas.sides.t + oeuvre.framing.canvas.sides.b;
							}
							if (oeuvre.framing.frame && oeuvre.framing.frame.sides) {
								w += oeuvre.framing.frame.sides.l + oeuvre.framing.frame.sides.r;
								h += oeuvre.framing.frame.sides.t + oeuvre.framing.frame.sides.b;
							}

							oeuvre._width  = oeuvre.plane.pxPcm * w;
							oeuvre._height = oeuvre.plane.pxPcm * h;

							var w2 = oeuvre._width  / 2;
							var h2 = oeuvre._height / 2;
							oeuvre.corners = [
								{ x: oeuvre.x - w2, y: oeuvre.y - h2 },
								{ x: oeuvre.x + w2, y: oeuvre.y - h2 },
								{ x: oeuvre.x + w2, y: oeuvre.y + h2 },
								{ x: oeuvre.x - w2, y: oeuvre.y + h2 }
							];
					}	
				};

				$scope.wallpreview.refreshSizes = function(){
					
					var oh = window.innerHeight - 2*25 - 50;
					var ow = window.innerWidth  - 2*25;
					
					if( ow > $scope.wallpreview.scene.ratio*oh ){
						$scope.wallpreview.scene.width  = $scope.wallpreview.scene.ratio * oh;
						$scope.wallpreview.scene.height = oh;
					} else if( oh > ow/$scope.wallpreview.scene.ratio ){
						$scope.wallpreview.scene.height = ow / $scope.wallpreview.scene.ratio;
						$scope.wallpreview.scene.width  = ow;
					}
					
					$scope.wallpreview.scene.canvas.width  = $scope.wallpreview.scene.width;
					$scope.wallpreview.scene.canvas.height = $scope.wallpreview.scene.height;

					return $scope.wallpreview.refreshPlanes();
				};
				$scope.wallpreview.refreshPlanes = function(){
					var _nrat;
					for( var i in $scope.wallpreview.planes ){
						var plane  = $scope.wallpreview.planes[ i ];
						var _pxPcm = plane.pxPcm;
						switch( $scope.wallpreview.planes[i].style ){
							case 3:
								var l = plane.corners.lt.x * $scope.wallpreview.scene.canvas.width;
								var r = plane.corners.rt.x * $scope.wallpreview.scene.canvas.width;
								plane.pxPcm = Math.abs((r - l) / plane.width_cm );
								break;
							default:
								var l = plane.corners.lt.x * $scope.wallpreview.scene.canvas.width;
								var r = plane.corners.rt.x * $scope.wallpreview.scene.canvas.width;
								plane.pxPcm = Math.abs((r - l) / plane.width_cm );
								break;
						}
						_nrat = plane.pxPcm / _pxPcm;
					}
					if( !isNaN(_nrat) && _nrat != 1 ){
						for( var i in $scope.wallpreview.oeuvres ){
							var oeuvre = $scope.wallpreview.oeuvres[i];
							if( !isNaN( oeuvre.x * oeuvre.y )){
								$scope.wallpreview.setOeuvrePositionByPoint( oeuvre, {
									x: oeuvre.x * _nrat,
									y: oeuvre.y * _nrat
								});
							}
						}
					}
				}

				$scope.wallpreview.initiateOeuvres = function( oeuvres ){
					return $q.all(oeuvres.map(function( oeuvre ){
						return $q(function(resolve, reject){
							
							var o = {
								oeuvre  : oeuvre,
								image   : new Image(),
								plane   : $scope.wallpreview.plane,
								_width  : 100,
								_height : 100,
								framing : angular.copy( oeuvre.with.images && oeuvre.with.images[oeuvre.with.oeuvre.img_uid] && oeuvre.with.images[oeuvre.with.oeuvre.img_uid].framing && oeuvre.with.images[oeuvre.with.oeuvre.img_uid].framing.custom || {})
							};

							try {

								if (o.framing.frame && o.framing.frame.color.toUpperCase().match( /^#[0-9A-F]{6}$/ ) && o.framing.frame.sides.length == 4) {
									o.framing.frame.sides = {
										l: o.framing.frame.sides[0],
										t: o.framing.frame.sides[1],
										b: o.framing.frame.sides[2],
										r: o.framing.frame.sides[3]
									};
								} else delete o.framing.frame;

								if (o.framing.canvas && o.framing.canvas.color.toUpperCase().match( /^#[0-9A-F]{6}$/ ) && o.framing.canvas.sides.length == 4) {
									o.framing.canvas.sides = {
										l: o.framing.canvas.sides[0],
										t: o.framing.canvas.sides[1],
										b: o.framing.canvas.sides[2],
										r: o.framing.canvas.sides[3]
									};
								} else delete o.framing.canvas;

							} catch(e){ console.error(e); }

							$scope.wallpreview.setOeuvrePositionByPoint( o, {
								x: $scope.wallpreview.scene.width  / 2,
								y: $scope.wallpreview.scene.height / 2
							});

							o.image.onload  = function(){ resolve( o ); };
							o.image.onerror = reject;
							o.image.src = "/i/"+ oeuvre.with.oeuvre.img_uid +"?size=normal";
						});
					}));
				};
				$scope.wallpreview.render = function(){
					var ctx = $scope.wallpreview.context;

					ctx.clearRect( 0, 0, $scope.wallpreview.scene.width, $scope.wallpreview.scene.height );
					ctx.fillStyle = "#000000";

					for( var i in $scope.wallpreview.oeuvres ){
						var o = $scope.wallpreview.oeuvres[ i ];
						var pxPcm = o.plane.pxPcm;

						var left   = o.x - o._width/2;
						var top    = o.y - o._height/2;
						var width  = o._width;
						var height = o._height;

						if (o.framing.frame) {
							ctx.fillStyle = o.framing.frame.color;
							ctx.fillRect( left, top, width, height );
							left   += pxPcm * (o.framing.frame.sides.l);
							top    += pxPcm * (o.framing.frame.sides.t);
							width  -= pxPcm * (o.framing.frame.sides.l + o.framing.frame.sides.r);
							height -= pxPcm * (o.framing.frame.sides.t + o.framing.frame.sides.b);
						}

						if (o.framing.canvas) {
							ctx.fillStyle = o.framing.canvas.color;
							ctx.fillRect( left, top, width, height );
							left   += pxPcm * (o.framing.canvas.sides.l);
							top    += pxPcm * (o.framing.canvas.sides.t);
							width  -= pxPcm * (o.framing.canvas.sides.l + o.framing.canvas.sides.r);
							height -= pxPcm * (o.framing.canvas.sides.t + o.framing.canvas.sides.b);
						}

						ctx.drawImage( o.image, left, top, width, height );
					}
				}
				
				$scope.wallpreview.openview = function( wall ) {

					var prms = $q.defer();	
					var planes = Object.keys(wall.data.planes).map(function(hash){ return wall.data.planes[ hash ]; });

					$scope.wallpreview.planes = planes;
					planes = planes[ 0 ];
					$scope.wallpreview.plane = planes;
					
					var $element  = $scope.wallpreview.$element  = null;
					var canvas    = $scope.wallpreview.canvas    = document.createElement( "canvas" );
					var context   = $scope.wallpreview.context   = null;
					var selection = $scope.wallpreview.selection = {};		

					canvas.style.position = "absolute";
					canvas.style.left     = "0px";
					canvas.style.top      = "0px";

					$scope.wallpreview.image = new Image();
					$scope.wallpreview.image.onload = function(){
						$timeout(function(){
							$element = $scope.wallpreview.$element = document.querySelector("#wallpreviewcontainer");
							if( !$scope.wallpreview.$element ){
								throw new Error( "Could not found $element!" );
							}
							$scope.wallpreview.scene = { ratio: $scope.wallpreview.image.width / $scope.wallpreview.image.height, canvas: canvas };
						}).then(function(){
							/*
							$scope.$watch(function(){
								
								return $scope.wallpreview.$element.clientWidth+"-"+$scope.wallpreview.$element.clientHeight;
							}, $scope.wallpreview.refreshSizes );
							*/
							
							return $timeout($scope.wallpreview.refreshSizes);
						}).then(function(){
							context = $scope.wallpreview.context = $scope.wallpreview.scene.context = $scope.wallpreview.canvas.getContext("2d");
							
							$element.querySelector(".scene-container").appendChild( canvas );

							return $scope.wallpreview.initiateOeuvres([ $scope.wallpreview.oeuvre ]);
							
						}).then(function(oeuvres){
							$scope.wallpreview.oeuvres = oeuvres;					
							
							$scope.wallpreview.canvas.addEventListener( "mousedown",   $scope.wallpreview.onPointerDown, false );
							$scope.wallpreview.canvas.addEventListener( "touchstart",  $scope.wallpreview.onPointerDown, false );

							$scope.wallpreview.canvas.addEventListener( "mousemove",   $scope.wallpreview.onPointerMove, false );
							$scope.wallpreview.canvas.addEventListener( "touchmove",   $scope.wallpreview.onPointerMove, false );

							$scope.wallpreview.canvas.addEventListener( "mouseup",     $scope.wallpreview.onPointerUp,   false );
							$scope.wallpreview.canvas.addEventListener( "touchcancel", $scope.wallpreview.onPointerUp,   false );
							$scope.wallpreview.canvas.addEventListener( "touchend",    $scope.wallpreview.onPointerUp,   false );
							
							
							document.body.addEventListener( "mouseup",     $scope.wallpreview.onPointerUp,   false );
							document.body.addEventListener( "touchcancel", $scope.wallpreview.onPointerUp,   false );
							document.body.addEventListener( "touchend",    $scope.wallpreview.onPointerUp,   false );

							document.querySelector("html").style.overflow = "hidden";
							
							$scope.wallpreview.loop();

							prms.resolve();
						}).catch( prms.reject );
					}

					$scope.wallpreview.wall_image_src = "/i/"+ wall.image_uid +"?size=large";
					$scope.wallpreview.image_src = $scope.wallpreview.wall_image_src;
					$scope.wallpreview.img_src   = $scope.wallpreview.image_src;
					$scope.wallpreview.image.src = $scope.wallpreview.image_src;

					return prms.promise;
				}


				/******************/

				function solveTargetByPoint( p ){
					var oeuvre;
					for( var i in $scope.wallpreview.oeuvres ){
						var o = $scope.wallpreview.oeuvres[ i ];
						if( pointInsideCorners( p, o.corners )){
							oeuvre = o;
							break;
						}
					}
					if( oeuvre ){
						console.log( "folved Oeuvre!", oeuvre);
						return {
							o_point: p,
							dx: p.x - oeuvre.x,
							dy: p.y - oeuvre.y,
							oeuvre: oeuvre
						};
					}
					function pointInsideCorners( p, c ){
						return p.x >= o.corners[0].x && p.x < o.corners[2].x && p.y >= o.corners[0].y && p.y < o.corners[2].y;
					}
				}

				function pointFromEvent( event ){
					var point = { x: event.layerX, y: event.layerY };
					var rect = $scope.wallpreview.scene.canvas.getBoundingClientRect();
					var x = rect.x || rect.left;
					var y = rect.y || rect.top;
					switch( event.type ){
						case "touchstart":
						case "touchend":
						case "touchcancel":
						case "touchmove":
							var touch = event.touches[ 0 ];
							return { x: touch.clientX - x, y: touch.clientY - y };
					}
					return {
						x: event.clientX - x,
						y: event.clientY - y
					};
				}
			} // initWallPreview();
		};
	}])
})();
